import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable"
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from "../../services/adal.http.service";

@Injectable()
export class ForgeRockUriManagementService {
    constructor(private http: AdalHttp) {
    }

    updateRedirectUris(applicationId: string, uri: Array<string>): Observable<any> {
        let productUrl = `/api/auth/applications/${applicationId}/redirecturis`;
        return this.http.put(productUrl, uri)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    updateLogoutUri(applicationId: string, uri: Array<string>): Observable<any> {
        let productUrl = `/api/auth/applications/${applicationId}/logouturis`;
        return this.http.put(productUrl, uri)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/forgerockUriManagement/forgerock-uri-management-service.ts
 **/